import React, { FC } from 'react'
import { HStack, StackProps, VStack } from '@chakra-ui/react'

export interface ISectionProps extends StackProps {
  title?: string
  isHorizontal?: boolean
}

/**
 * Section component.
 *
 * Works as a wrapper of a certain section showing the title of the section itself.
 *
 * Can be combined with the `SectionList` and  `SectionListItem` components.
 */

export const Section: FC<ISectionProps> = ({
  children,
  isHorizontal = false,
  ...rest
}) => {

  const Wrapper = isHorizontal ? HStack : VStack

  return (
    <Wrapper
      alignItems="stretch"
      data-testid="section-container"
      width="full"
      {...(isHorizontal ? { spacing: '4em' } : {})}
      {...rest}
    >
      {children}
    </Wrapper>
  )
}
